const calculateRange = (selectedPage, total, pageRange) => {
    const additionalPagesToShow = pageRange === 7 ? 6 : 4;
    const beforePagesToSHow = additionalPagesToShow / 2;
    let startRange = Math.min(selectedPage - beforePagesToSHow, total - additionalPagesToShow);
    if (selectedPage <= beforePagesToSHow) {
        startRange = 1;
    }
    const endRange = startRange + additionalPagesToShow;
    return {
        startRange,
        endRange,
    };
};

export { calculateRange };
